/*
    Example call:
        let modal = new Modal({
            modal:'.js-modal',      //* container holding modal
            modalActivator:'#burger-nav',       //* element that activates a Modal
            modalCancel: '.js-modal__cancel',       //* elements on which Modal will hide
        });
        modal.init();
*/
let Modal = function(args){
    const that = this;

    this.init = function(){
        this.cacheDom();
        bindEvents();
    }
    this.cacheDom = function(){
        this.modal = document.querySelector(args.modal);
        this.modalActivator = document.querySelector(args.modalActivator);
        this.modalCancel = this.modal.querySelectorAll(args.modalCancel);
    }
    function bindEvents(){
        that.modalActivator.addEventListener('click', showModal);
        that.modalCancel.forEach(function(elem){
            elem.addEventListener('click', hideModal);
        });
    }
    function showModal(){
        that.modal.classList.add('active');
    }
    function hideModal(){
        that.modal.classList.remove('active');
    }
}


/*
    Example call:
        let modalForm = new ModalForm({
            modal:'.js-wpcf7-response-modal',       //* container holding modal
            formResponse:'.wpcf7-response-output',      //* wpcf7 response div
            modalCancel: '.js-modal__cancel',       //* elements on which Modal will hide
        });
        formModal.init();
*/
let ModalForm = function(args){
    let that = this;

    this.init = function(){
        this.cacheDom();
        bindEvents();
    }
    this.cacheDom = function(){
        this.modalFlag = false;
        this.modal = document.querySelector(args.modal);
        this.formResponse = document.querySelector(args.formResponse);
        this.modalCancel = this.modal.querySelectorAll(args.modalCancel);
    }
    function bindEvents(){
        if(that.formResponse){
            that.formResponse.addEventListener('DOMNodeInserted', showModal);
        }
        that.modalCancel.forEach(function(elem){
            elem.addEventListener('click', hideModal);
        });
    }
    function showModal(){
        that.modal.querySelector('.js-modal__body-p').innerText = that.formResponse.innerText;
        that.modal.classList.add('is-active');
    }
    function hideModal(){
        that.modal.classList.remove('is-active');
    }
}


module.exports = {ModalForm, Modal};